// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/image-off.js';

import { paths } from '../generated/image-off';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('image-off', Original, paths);
